module.exports = __webpack_public_path__ + "static/img/crmdown3.4c884c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/center/crmdown3.png
// module id = Vpaq
// module chunks = 89